module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "content-class": "edit-post-modal",
      "max-width": "900px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.postData) ? _c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Edit Draft")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    attrs: {
      "id": "campaignForm"
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "name": "campaignName",
      "disabled": typeof _vm.postData.submittedCampaignName === 'string'
    },
    model: {
      value: (_vm.postData.campaignName),
      callback: function($$v) {
        _vm.$set(_vm.postData, "campaignName", $$v)
      },
      expression: "postData.campaignName"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [(_vm.postData.author) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "35",
      "color": "grey lighten-4"
    }
  }, [_c('img', {
    staticClass: "elevation-6",
    attrs: {
      "src": _vm.paserImageUrl(_vm.postData.author.picture),
      "alt": "avatar"
    }
  })]), _vm._v(" "), (_vm.postData.author.tiktokHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.postData.author.tiktokHandle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.postData.author.tiktokHandle))]) : (_vm.postData.author.youtubeHandle) ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/' + _vm.postData.author.youtubeHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.postData.author.youtubeHandle))], 1) : (_vm.postData.author.xhsHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.xiaohongshu.com/user/profile/' + _vm.postData.author.xhsHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.postData.author.xhsHandle))]) : (_vm.postData.author.linkedinHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.postData.author.linkedinHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.postData.author.linkedinHandle))], 1) : (_vm.postData.type === 'twitter' || _vm.postData.author.twitterHandle) ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + (_vm.postData.author.twitterHandle || _vm.postData.author.instagramHandle),
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.postData.author.twitterHandle || _vm.postData.author.instagramHandle))]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.postData.author.instagramHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.postData.author.instagramHandle))], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData.type) ? _c('v-chip', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("platformDisplayName")(_vm.postData.type)) + "\n                  ")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "md": (_vm.postAbuseHistory && _vm.clientReportAbuse.length > 0) ? 8 : 12,
      "xs": "12"
    }
  }, [_c('v-container', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "grid-list-sm": "",
      "container--fluid": ""
    }
  }, [(_vm.viewImages.length === 0) ? _c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "align-center": "",
      "justify-center": "",
      "ma-0": ""
    }
  }, [_c('p', [_vm._v("No Media to show")])]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('draggable', {
    staticClass: "row align-center justify-center",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": _vm.dragEnd
    },
    model: {
      value: (_vm.viewImages),
      callback: function($$v) {
        _vm.viewImages = $$v
      },
      expression: "viewImages"
    }
  }, _vm._l((_vm.viewImages), function(img, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "mb-3",
      attrs: {
        "md4": "",
        "xs12": ""
      }
    }, [(_vm.isMissingMedia(img)) ? _c('div', [_c('v-alert', {
      attrs: {
        "type": "warning",
        "outlined": ""
      }
    }, [_vm._v("\n                            This media file is missing. Remove it and upload the original file again.\n                          ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "block": "",
        "dark": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImages(i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("delete")]), _vm._v("Remove\n                          ")], 1)], 1) : (img.publicID && img.isvideo) ? _c('div', [_c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('v-hover', [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img)
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "text-center mt-2"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "dark": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImages(i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("delete")]), _vm._v("Remove\n                              ")], 1), _vm._v(" "), _c('btn-download', {
      attrs: {
        "url": img.url,
        "className": "mt-0"
      }
    })], 1)])], 1) : _c('v-card', {
      staticClass: "elevation-0",
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [(!img.isvideo) ? _c('div', [(!img.isvideo && !img.publicID) ? _c('v-img', {
      staticClass: "grey lighten-2 mx-auto",
      attrs: {
        "src": img.url,
        "lazy-src": img.url,
        "aspect-ratio": "1"
      }
    }) : _vm._e(), _vm._v(" "), (img && !img.isvideo && img.publicID) ? _c('div', {
      staticClass: "cursor-pointer"
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {})
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text-center mt-2"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "small": "",
        "dark": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImages(i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("delete")]), _vm._v("Remove\n                                ")], 1), _vm._v(" "), _c('btn-download', {
      attrs: {
        "url": img.url,
        "className": "mt-0"
      }
    })], 1)])], 1) : _vm._e(), _vm._v(" "), (img.isvideo) ? _c('v-card', {
      staticClass: "elevation-8",
      attrs: {
        "text": ""
      }
    }, [_c('v-card-text', [_c('video', {
      attrs: {
        "id": "previewVideo",
        "width": "100%",
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": img.url,
        "type": "video/mp4"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "px-2"
    }, [(img.type === 'video/quicktime') ? _c('btn-download', {
      attrs: {
        "url": img.url
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "text": "",
        "block": "",
        "dark": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImages(i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("delete")]), _vm._v("Remove\n                            ")], 1)], 1)], 1) : _vm._e()], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "color": "blue-grey",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_vm._v("\n                  Add Media\n                  "), _c('v-icon', {
    attrs: {
      "float-right": "",
      "dark": ""
    }
  }, [_vm._v("cloud_upload")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "images",
      "id": "fileToUpload",
      "accept": "image/*, video/*",
      "multiple": ""
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.isCaptionText) ? _c('div', [_c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "name": "captionText",
      "label": "Current Caption",
      "value": _vm.postData.defaultCaptionText,
      "counter": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "4",
      "name": "captionText",
      "label": _vm.captionLabel,
      "rules": [_vm.rules.length(2200)],
      "counter": ""
    },
    model: {
      value: (_vm.postData.captionText),
      callback: function($$v) {
        _vm.$set(_vm.postData, "captionText", $$v)
      },
      expression: "postData.captionText"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isVideoLink) ? _c('div', [_c('v-text-field', {
    attrs: {
      "filled": "",
      "clearable": "",
      "name": "vdoLink",
      "type": "text",
      "label": "Link (If your file size is bigger than 100mb or the video fails to upload, please insert a video/drive link here)",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.postData.vdoLink),
      callback: function($$v) {
        _vm.$set(_vm.postData, "vdoLink", $$v)
      },
      expression: "postData.vdoLink"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isRemark) ? _c('div', [_c('div', {
    staticClass: "kobe-remark-editor-label"
  }, [_vm._v("Kobe Remark")]), _vm._v(" "), _c('sun-editor', {
    staticClass: "kobe-remark-editor",
    attrs: {
      "content": _vm.postData.remark || '',
      "width": "100%",
      "height": "180",
      "source": "post"
    },
    on: {
      "contentChanged": function($event) {
        _vm.postData.remark = $event
      },
      "loadingDialogOpen": function($event) {
        _vm.loading = true
      },
      "loadingDialogClose": function($event) {
        _vm.loading = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isHashTag) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "4",
      "name": "mandatoryHashtag",
      "label": "Mandatory Hashtag & Mentions",
      "counter": ""
    },
    model: {
      value: (_vm.postData.mandatoryHashtag),
      callback: function($$v) {
        _vm.$set(_vm.postData, "mandatoryHashtag", $$v)
      },
      expression: "postData.mandatoryHashtag"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isCallToActionLinks) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "4",
      "name": "callToActionLinks",
      "label": "Call to Action Links",
      "counter": ""
    },
    model: {
      value: (_vm.postData.callToActionLinks),
      callback: function($$v) {
        _vm.$set(_vm.postData, "callToActionLinks", $$v)
      },
      expression: "postData.callToActionLinks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.postAbuseHistory && _vm.clientReportAbuse.length > 0) ? _c('v-col', {
    attrs: {
      "md": "4",
      "xs": "12"
    }
  }, [_c('v-expansion-panels', {
    staticClass: "report-abuse-section-edit"
  }, _vm._l((_vm.clientReportAbuse), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', [_c('div', {
      staticClass: "subtitle-1",
      attrs: {
        "color": "red lighten-4"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "deep-orange"
      }
    }, [_vm._v("report_problem")]), _vm._v("\n                        Reported Abuse\n                      ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', [_c('v-card-text', {
      staticClass: "grey lighten-3"
    }, [_c('h4', [_vm._v("Reasons for Non-Approval")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.reasons), function(r) {
      return _c('li', {
        key: r
      }, [_vm._v(_vm._s(r))])
    }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Comments for Abuse:")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(item.comment) + "\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-right caption font-weight-italic"
    }, [_vm._v(_vm._s(_vm.formatDate(item.date)))])])], 1)], 1)], 1)
  }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.allowDelete) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.deletePost()
      }
    }
  }, [_vm._v("Delete Post")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "green"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf236974"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/EditPost.vue
// module id = 2290
// module chunks = 0